import angular from 'angular';

type AlertType = 'default' | 'info' | 'warning';

/**
 * @param iconName FontAwesome icon name
 * @returns FontAwesome icon classes
 */
function normalizeIconClass(iconName: string) {
  return 'fa fa-lg fa-' + iconName;
}

function normalizeAlertClass(type: AlertType) {
  return 'acme-alert acme-alert--' + type;
}

class AlertController {
  static $inject = ['$element'];
  static icons = {
    info: normalizeIconClass('info-circle'),
    warning: normalizeIconClass('exclamation-circle'),
    error: normalizeIconClass('exclamation-circle'),
    success: normalizeIconClass('check-circle'),
  };

  icon = '';
  type: AlertType = 'default';
  iconClass = '';

  constructor(private $element: JQuery) {}

  $onChanges() {
    const alertClass = normalizeAlertClass(this.type);
    this.$element.addClass(alertClass);
    this.iconClass = this.icon ? normalizeIconClass(this.icon) : AlertController.icons[this.type] || null;
  }
}

export const AlertComponentModule = angular.module('acme.common.component.alert', []).component('acmeAlert', {
  templateUrl: 'common/components/alert/alert.component.tpl.html',
  controller: AlertController,
  transclude: true,
  bindings: {
    /**
     * Allows overriding the icon
     */
    icon: '<',
    type: '<',
  },
}).name;
